import React from 'react'

export default class NotFoundPage extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return <div>404 - Page not found</div>
  }
}
